import React, { useState } from "react";
import { Upload } from "lucide-react";
import { importTemplateCsv, MAX_IMPORT_ROWS } from "@/helpers/csvRows";
import "./CsvDropzone.scss";

const downloadTemplate = () => {
  const blob = new Blob([importTemplateCsv()], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "client-import-template.csv";
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking in the same tick cancels the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

const CsvDropzone = ({ inputRef, onFile }) => {
  const [dragging, setDragging] = useState(false);
  return (
    <div className="csv-dropzone">
      <label
        className={`cdz-drop${dragging ? " is-dragging" : ""}`}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragging(false);
          onFile(e.dataTransfer?.files?.[0]);
        }}
      >
        <span className="cdz-icon" aria-hidden>
          <Upload size={22} strokeWidth={1.75} />
        </span>
        <span className="cdz-title">Drop your CSV here</span>
        <span className="cdz-text">
          or <span className="cdz-choose">choose a file</span>. Up to{" "}
          {MAX_IMPORT_ROWS.toLocaleString("en-US")}&nbsp;rows.
        </span>
        <input
          ref={inputRef}
          type="file"
          accept=".csv,text/csv"
          onChange={(e) => onFile(e.target.files?.[0])}
          data-testid="csv-file-input"
        />
      </label>
      <p className="cdz-lead">
        <button type="button" className="cdz-link" onClick={downloadTemplate}>
          Download the template
        </button>
      </p>
    </div>
  );
};

export default CsvDropzone;
